import { Card, CardBody, Col, } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FormatedLabels } from "../../../../Constant";
import FormatedLabelForm from "./FormatedLabelForm";

const FormatedLabel = () => {
  
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={FormatedLabels} />
        <CardBody>
        <FormatedLabelForm/>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FormatedLabel;
